import React from 'react';
import { t } from 'i18n';

import InputGroup from 'Components/Forms/InputGroup';
import Checkbox from 'Components/Forms/Checkbox';
import { Icon } from 'Components/Base';
import { firstName } from 'Utilities/patientHelper';

// "name" prop represents the target name of the field, e.g. for the
// second PCG added name will be "primaryCaregiver[1]" ...

const i18nOpts = { scope: 'care_plan_creators.careteam.primary_caregiver_form.sdm_type' }
const i18nConfirmationOpts = { scope: 'care_plan_creators.careteam.primary_caregiver_form' }

const SubstituteDecisionMakerInput = ({
  name,
  patientName,
  onChange,
  sdmInfo,
  errors
}) => {
  const SDM_TYPES = ['substitute_decision_maker', 'poa_personal_care', 'poa_finances', 'guardian_trustee'];
  const SDM_TYPES_OPTIONS = SDM_TYPES.map(option => ({ value: option, label: t(option, i18nOpts) }));

  const { isSdm, isConfirmed, sdmTypes } = sdmInfo;

  const patientFirstName = firstName(patientName);

  const setIsSdm = (value) => {
    onChange({ target: { name: `${name}.sdmInfo.isSdm`, value } });
  };

  const toggleIsConfirmed = () => {
    onChange({ target: { name: `${name}.sdmInfo.isConfirmed`, value: !isConfirmed } });
  }

  const unassignSdm = () => {
    onChange({ target: { name: `${name}.sdmInfo.sdmTypes`, value: [] } });
    onChange({ target: { name: `${name}.sdmInfo.isConfirmed`, value: false } });
    onChange({ target: { name: `${name}.sdmInfo.isSdm`, value: false } });
  }

  if (!isSdm) return (
    <div className="assign-sdm">
      <a
        className="assign-sdm__button"
        tabIndex="0"
        onClick={() => setIsSdm(true)}
        onKeyDown={(evt) => {
          if (evt.key === ' ' || evt.key === 'Enter') {
            setIsSdm(true);
          }
        }}
      >
        {`＋ ${t('assign_button', { ...i18nOpts, patient_first_name: patientFirstName })}`}
      </a>
    </div>
  );

  return <>
    <div className="assign-sdm">
      <InputGroup
        component="multi-select"
        name={`${name}.sdmInfo.sdmTypes`}
        onChange={selected => {
          onChange({
            target: {
              name: `${name}.sdmInfo.sdmTypes`,
              value: selected.map(option => option.value),
            },
          });
        }}
        value={SDM_TYPES_OPTIONS.filter(option => sdmTypes.includes(option.value))}
        label={t('label', i18nOpts)}
        errors={errors}
        options={SDM_TYPES_OPTIONS}
      />

      <div className="assign-sdm__remove-container">
        <button
          className="btn--link btn--icon assign-sdm__remove-button"
          onClick={unassignSdm}
        >
          <Icon className="icon--medium icon__trash" name="trash" />
        </button>
      </div>
    </div>
    {
      !!sdmTypes?.length && (
        <Checkbox
          name={`${name}.sdmInfo.isConfirmed`}
          text={t('sdm_confirmed', i18nConfirmationOpts)}
          checked={isConfirmed}
          onChange={toggleIsConfirmed}
          errors={errors}
        />
      )
    }
  </>
}

export default SubstituteDecisionMakerInput;
